import React from 'react';
import { useTranslation } from 'react-i18next';
import { Languages } from 'lucide-react';

export default function LanguageSwitcher() {
  const { i18n } = useTranslation();

  const toggleLanguage = () => {
    const newLang = i18n.language.startsWith('it') ? 'en' : 'it';
    i18n.changeLanguage(newLang).catch(console.error);
  };

  return (
    <button
      onClick={toggleLanguage}
      className="flex items-center px-3 py-2 text-gray-700 hover:text-blue-600 transition-colors"
      title={i18n.language.startsWith('it') ? 'Switch to English' : 'Passa all\'italiano'}
    >
      <Languages className="w-5 h-5" />
      <span className="ml-2 text-sm font-medium">
        {i18n.language.startsWith('it') ? 'EN' : 'IT'}
      </span>
    </button>
  );
}